import type { ReactElement, ReactNode } from 'react';
import { Children, isValidElement } from 'react';

const groupBy = (
  children: ReactNode[],
  classifier: (node: ReactElement) => string | undefined,
): Record<string, ReactNode[]> => {
  return Children.toArray(children).reduce(
    (groups: Readonly<Record<string, ReactNode[]>>, child: ReactNode) => {
      const newGroups = { ...groups };
      const key = isValidElement(child) ? classifier(child) || 'rest' : 'rest';

      if (typeof newGroups[key] === 'undefined') {
        newGroups[key] = [];
      }

      newGroups[key] = [...newGroups[key], child];

      return newGroups;
    },
    {},
  );
};

export default groupBy;
